import React, { Suspense } from "react";
import Loader from "../component/Loader";
const ForgetPasswordPage = React.lazy(() => import("../app/forgetPassword"));

function ForgetPassword() {
  return (
    <>
      <Suspense fallback={<Loader />}>
        <ForgetPasswordPage />
      </Suspense>
    </>
  );
}

export default ForgetPassword;
